export default __webpack_public_path__ + "static/media/poyika.305f12c2.jpg";